import type { EvidenceItem } from '@/domains/report/api/types';

/** Eén passage van één criterium; dezelfde zin onder twee criteria zijn twee selecties. */
export type EvidenceSelection = {
  criterionId: string;
  evidence: EvidenceItem;
};

/** Zelfde formaat als de dedupe-sleutel in useDocumentEvidence, zodat een selectie precies één resultaat raakt. */
export function evidenceSelectionKey(
  criterionId: string,
  evidence: Pick<EvidenceItem, 'pages' | 'sentence'>,
): string {
  return `${criterionId}|${evidence.pages?.join(',') ?? ''}|${evidence.sentence ?? ''}`;
}
